export const DEMO_ANCHOR = 'demo' as const;
